import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class RecommendedSortAdoptionStatDto {
  @Field()
  date!: Date

  // Distinct readers who visited the feed that day — recommendedUsers + newUsers, the
  // chart's "100%" for the day.
  @Field(t => Int)
  totalUsers!: number

  // Distinct readers whose LAST feed sort choice that day was Recommended.
  @Field(t => Int)
  recommendedUsers!: number

  // Distinct readers whose LAST feed sort choice that day was New.
  @Field(t => Int)
  newUsers!: number
}
